module.exports = __webpack_public_path__ + "img/triangleRightBlack.24e5fc55.svg";